export enum Service {
  Campaigns = 'Campaigns:Campaigns',
  Rulesets = 'Campaigns:Rulesets',
  RulesetSplitTests = 'Campaigns:RulesetSplitTests',
  SplitTests = 'Campaigns:SplitTests',
  FrequencyCaps = 'Campaigns:FrequencyCaps',
  IpWhitelist = 'Campaigns:IpWhitelist',
  GlobalIpWhitelist = 'Campaigns:GlobalIpWhitelist',
}
